import React, { createContext, FunctionComponent, useCallback, useContext, useMemo, useState } from 'react';

type AccordionState = Record<string, Record<string, boolean>>;

type TrainingAccordionContextValue = {
  getExpanded: (farmName: string, key: string) => boolean;
  setExpanded: (farmName: string, key: string, isExpanded: boolean) => void;
};

const TrainingAccordionContext = createContext<TrainingAccordionContextValue>({
  getExpanded: () => false,
  setExpanded: () => {},
});

export const TrainingAccordionProvider: FunctionComponent = ({ children }) => {
  const [state, setState] = useState<AccordionState>({});

  const getExpanded = useCallback(
    (farmName: string, key: string) => state[farmName]?.[key] ?? false,
    [state]
  );

  const setExpanded = useCallback((farmName: string, key: string, isExpanded: boolean) => {
    setState((prev) => ({
      ...prev,
      [farmName]: { ...prev[farmName], [key]: isExpanded },
    }));
  }, []);

  const value = useMemo(() => ({ getExpanded, setExpanded }), [getExpanded, setExpanded]);

  return <TrainingAccordionContext.Provider value={value}>{children}</TrainingAccordionContext.Provider>;
};

export const useTrainingAccordion = () => useContext(TrainingAccordionContext);
